// @flow

import ajax from 'services/ajax/ajax';
import type { MapSuccess, MapFailure } from 'type/type';
import url from '@active/awe-ui-core/lib/services/url';

export const get = (
  participantId: number,
  mapSuccess: MapSuccess,
  mapFailure?: MapFailure,
) => ajax.get(`/results/participants/${participantId}`, { mapSuccess, mapFailure });

export const getSplitResults = (
  participantId: number,
  mapSuccess: MapSuccess,
  mapFailure?: MapFailure,
) => ajax.get(
  `/results/participants/${participantId}/splits`, {
    mapSuccess,
    mapFailure,
  });

export const list = (
  param: { applicationName: string, q: string, offset: number, limit: number },
  mapSuccess: Function,
  mapFailure: ?Function,
) => ajax.get(
  url(`/results/search/events/${param.applicationName}/participants`)
    .appendParam('q', param.q)
    .appendParam('offset', param.offset)
    .appendParam('limit', param.limit)
    .value(), {
    mapSuccess,
    mapFailure,
  });

export const getByNumber = (
  {
    registrationNumber,
    eventId,
    resubmit,
  }: {
    registrationNumber: string,
    eventId: string,
    resubmit: boolean,
  },
  mapSuccess: MapSuccess,
  mapFailure?: MapFailure,
) => ajax.get({
  url: url(`/results/events/${eventId}/participants/${registrationNumber}`)
    .appendParam('resubmit', resubmit)
    .value(),
  headers: {
    'Content-Type': 'application/vnd.active.results-service.v1+json',
  },
}, { mapSuccess, mapFailure });
